module.exports = __webpack_public_path__ + "img/file.b14eca21.svg";